import { ReduxStore } from 'store/types';

function changeStatusIsLoading(state: ReduxStore): boolean {
  return state.user.changeStatus.config.isLoading;
}

export default changeStatusIsLoading;
